import { loanOfficerSubscriptionInfoHooks } from 'reducers/slices/loanOfficer/subscriptionInfoSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';

const useLoanOfficerSubscription = () => {
  const { subscriptionInfo, loadSubscriptionInfo, updateSubscriptionInfo } = loanOfficerSubscriptionInfoHooks.use();

  return {
    subscriptionInfo: subscriptionInfo.item ? subscriptionInfo.item : null,
    isSubscriptionInfoLoading: useFetchStatus(subscriptionInfo.loadingStatus).isPending,
    isSubscriptionInfoUpdating: useFetchStatus(subscriptionInfo.updatingStatus).isPending,
    loadSubscriptionInfo,
    updateSubscriptionInfo,
  };
};

export default useLoanOfficerSubscription;



// WEBPACK FOOTER //
// ./src/reducers/hooks/loanOfficer/useSubscriptionInfo.js